import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& *' : {
      userSelect: 'none'
    }
  },
  card: {
    display: 'flex',
    margin: '16px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
  },
  button: {
    marginTop: '16px'
  },
  title: {
    marginBottom: '16px',
    marginRight: '48px',
    display: 'flex',
    alignItems: 'center'
  }

}))